import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PublicLayout } from './components/layout/PublicLayout'
import { HomePage } from './pages/public/HomePage'
import { PwaRouteMemory } from './components/pwa/PwaRouteMemory'
import { RouteErrorBoundary } from './components/common/RouteErrorBoundary'

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'))
const AuthEntry = lazy(() => import('./AuthEntry'))
const ServicesPage = lazy(() => import('./pages/public/ServicesPage').then((module) => ({ default: module.ServicesPage })))
const ProjectsPage = lazy(() => import('./pages/public/ProjectsPage').then((module) => ({ default: module.ProjectsPage })))
const AboutPage = lazy(() => import('./pages/public/AboutPage').then((module) => ({ default: module.AboutPage })))
const ContactPage = lazy(() => import('./pages/public/ContactPage').then((module) => ({ default: module.ContactPage })))
const QuotePage = lazy(() => import('./pages/public/QuotePage').then((module) => ({ default: module.QuotePage })))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage })))
const BusinessCardPage = lazy(() => import('./pages/public/BusinessCardPage').then((module) => ({ default: module.BusinessCardPage })))
const EstimateReviewPage = lazy(() => import('./pages/public/EstimateReviewPage').then((module) => ({ default: module.EstimateReviewPage })))
const EstimateTermsPage = lazy(() => import('./pages/public/EstimateTermsPage').then((module) => ({ default: module.EstimateTermsPage })))

function AuthenticatedArea({ area }) {
  return <RouteErrorBoundary><AuthenticatedApp area={area} /></RouteErrorBoundary>
}

function AuthPageArea({ page }) {
  return <RouteErrorBoundary><AuthEntry page={page} /></RouteErrorBoundary>
}

export default function App() {
  return (
    <>
      <PwaRouteMemory />
      <RouteErrorBoundary>
        <Suspense fallback={<div className="route-loader" role="status">Loading…</div>}>
          <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="quote" element={<QuotePage />} />
            <Route path="login" element={<AuthPageArea page="login" />} />
            <Route path="forgot-password" element={<AuthPageArea page="forgot-password" />} />
          </Route>

          <Route path="admin/*" element={<AuthenticatedArea area="admin" />} />
          <Route path="employee/*" element={<AuthenticatedArea area="employee" />} />
          <Route path="client/*" element={<AuthenticatedArea area="client" />} />
          <Route path="card/:userId" element={<BusinessCardPage />} />
          <Route path="estimate/:estimateId" element={<EstimateReviewPage />} />
          <Route path="estimate/:estimateId/terms" element={<EstimateTermsPage />} />
          <Route path="/dashboard" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </RouteErrorBoundary>
    </>
  )
}
